module.exports = __webpack_public_path__ + "media/images/lp/1/plight5-pc-7ab97f4d5fc9c0acf6a639ea7142739b.png";